import { _apiPost, _apiPut, _apiDelete } from "../../lib/apiClient";

export async function apiCreateTask(payload) { return _apiPost("/tasks", payload); }
export async function apiUpdateTask(id, payload) { return _apiPut(`/tasks/${id}`, payload); }
export async function apiDeleteTask(id) { return _apiDelete(`/tasks/${id}`); }
